import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-scroll";
import "../Styles/header.css";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState("");

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    setIsScrolled("");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10) {
        setIsScrolled("isScrolled");
      } else {
        setIsScrolled("");
      }
    });
  }, []);

  return (
    <div className="header-container" id={"header"} ref={ref}>
      <div id="mask" />
      <div className="header_container">
        <header className={`${isScrolled}`}>
          <Link to={"header"} smooth={true}>
            <div id="header-logo"></div>
          </Link>
          <div id="span-header">
            <Link to={"about"} smooth={true}>
              <span>Sobre</span>
            </Link>
            <Link to={"solutions"} smooth={true} offset={-300}>
              <span>Nossas Soluções</span>
            </Link>
            <Link to={"contact-container"} smooth={true} offset={-150}>
              <span>Fale com um especialista</span>
            </Link>
          </div>
        </header>
        <div>
          <span
            id="content-header"
            className={inView ? "animate__animated animate__zoomIn" : ""}
          >
            Somos digitais antenados & disciplinados.
          </span>
        </div>
      </div>
    </div>
  );
}
